import React, { useState, useRef } from "react";
import "styles/jobs.css";
import {
	Container,
	Button,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
	CustomInput,
	Alert,
} from "reactstrap";
import { sendCOVIDQuestion } from "api";
import { Link } from "react-router-dom";

const SuccessAlert = (props) => {
	return (
		<div>
			<Alert color="success">
				<h4 className="alert-heading">COVID-19 Question Submitted!</h4>
				<p>
					One of our researchers will try and answer your question. You will be
					notified via email whenever the question gets answered.
				</p>
				<hr />
				<p className="mb-0">
					In the meantime feel free to browse our COVID-19 realated research{" "}
					<Link to="/covid-19">here</Link>. Or checkout the{" "}
					<Link to="/covid-19/faqs">previously asked questions</Link>.
				</p>
			</Alert>
		</div>
	);
};
const ErrorAlert = (props) => {
	return (
		<div>
			<Alert color="danger">
				<h4 className="alert-heading">Whoops!</h4>
				<p>
					Seems like there was an error submitting your question. Please check
					your email and the question field and try again.
				</p>
				<hr />
				<p className="mb-0">
					In the meantime feel free to browse our COVID-19 realated research
					<Link to="/covid-19">here</Link>. Or checkout the{" "}
					<Link to="/covid-19/faqs">previously asked questions</Link>.
				</p>
			</Alert>
		</div>
	);
};

const CovidQuestion = (props) => {
	const [form, setForm] = useState({});
	const [status, setStatus] = useState({
		isLoading: false,
		isSuccess: false,
		isError: false,
	});

	function handleChange(event) {
		const target = event.target;
		const value = target.checked ? target.checked : target.value;
		const name = target.name;
		setForm({
			...form,
			[name]: value,
		});
	}
	function handleSubmit(event) {
		event.preventDefault();
		sendCOVIDQuestion(form).then((res) => {
			console.log(res);
			if (res?.success) {
				console.log(res);
				setStatus({ isLoading: false, isSuccess: true });
				setForm({});
			} else if (res?.error) {
				console.log(res);
				setStatus({ isLoading: false, isError: true });
			}
		});
	}
	return (
		<Container className="form-container">
			<h2>Submit a COVID-19 Related Question for our Experts to Answer</h2>
			<div style={{ display: "flex" }}>
				<Button
					tag={Link}
					to="/covid-19/faqs"
					style={{ marginLeft: "auto" }}
					size="sm"
					color="primary"
					outline
				>
					View Previous COVID-19 Questions
				</Button>
			</div>
			{status.isError && <ErrorAlert />}
			{status.isSuccess && <SuccessAlert />}
			<Form onSubmit={handleSubmit} onChange={handleChange}>
				<FormGroup>
					<Label for="Name">Name</Label>
					<Input type="text" name="name" id="Name" />
				</FormGroup>
				<FormGroup>
					<Label for="email">Email</Label>
					<Input type="email" name="email" id="email" />
				</FormGroup>

				<FormGroup>
					<Label for="question">COVID-19 Question</Label>
					<Input
						type="textarea"
						name="question"
						id="question"
						maxLength={5000}
						rows={6}
					/>
					<FormText color="muted">
						* {5000 - (form?.question?.length ?? 0)} characters remaining
					</FormText>
				</FormGroup>
				<Button color="primary">Submit COVID-19 Question</Button>
			</Form>
		</Container>
	);
};

export default CovidQuestion;
